import { RouteGroup, SingleRoute } from '@Constants/routes';
import { Groups } from '../Groups';
import { AddGroup } from '../pages/AddGroup/AddGroup';
import { EditGroupFetch } from '../pages/EditGroup/EditGroupFetch';

export const GroupRouteGroup: RouteGroup = {
	code: 'v-enrl-cl',
	icon: 'feed',
	component: <Groups />,
	forceNavigate: true,
	route: 'groups',
	title: 'Groups',
	isRouted: true,
	isParent: true,
	routes: [
		{
			route: 'create',
			component: <AddGroup />,
		} as SingleRoute,
		{
			route: 'edit/:groupId',
			component: <EditGroupFetch />,
		} as SingleRoute,
	],
};
